import resources from '../resources';

export const LOADING = 'PHONE_CONTROL/LOADING';
export const LOADED = 'PHONE_CONTROL/LOADED';
export const LOAD_FAILED = 'PHONE_CONTROL/LOAD_FAILED';
export const loadPhones = () => {
  return (dispatch) => {
    dispatch({ type: LOADING });

    return new Promise((resolve, reject) => {
      resources.station
        .index({})
        .then((phones) => {
          const sortedPhones = phones.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            return 0;
          });
          dispatch({ type: LOADED, phones: sortedPhones });
          resolve(sortedPhones);
        })
        .catch((err) => {
          dispatch({ type: LOAD_FAILED, error: err });
          reject(err);
          return;
        });
    });
  };
};

export const ENABLING = 'PHONE_CONTROL/ENABLING';
export const ENABLED = 'PHONE_CONTROL/ENABLED';
export const ENABLE_FAILED = 'PHONE_CONTROL/ENABLE_FAILED';
export const enablePhone = (id) => {
  return (dispatch) => {
    dispatch({ type: ENABLING, id });

    return new Promise((resolve, reject) => {
      resources.station
        .putStatus(id, 'Enabled')
        .then(() => {
          dispatch({ type: ENABLED, id });
          dispatch(loadPhones()).then(resolve);
        })
        .catch((err) => {
          if (err) {
            dispatch({ type: ENABLE_FAILED, id, error: err });
            reject(err);
            return;
          }
        });
    });
  };
};

export const DISABLING = 'PHONE_CONTROL/DISABLING';
export const DISABLED = 'PHONE_CONTROL/DISABLED';
export const DISABLE_FAILED = 'PHONE_CONTROL/DISABLE_FAILED';
export const disablePhone = (id) => {
  return (dispatch) => {
    dispatch({ type: DISABLING, id });

    return new Promise((resolve, reject) => {
      resources.station
        .putStatus(id, 'Disabled')
        .then(() => {
          dispatch({ type: DISABLED, id });
          dispatch(loadPhones()).then(resolve);
        })
        .catch((err) => {
          dispatch({ type: DISABLE_FAILED, id, error: err });
          reject(err);
          return;
        });
    });
  };
};

export const ENABLING_MULTIPLE = 'PHONE_CONTROL/ENABLING_MULTIPLE';
export const ENABLED_MULTIPLE = 'PHONE_CONTROL/ENABLED_MULTIPLE';
export const ENABLE_MULTIPLE_FAILED = 'PHONE_CONTROL/ENABLE_MULTIPLE_FAILED';
export const enableMultiple = (ids) => {
  return (dispatch) => {
    dispatch({ type: ENABLING_MULTIPLE, ids });

    return new Promise((resolve, reject) => {
      resources.station
        .putMultipleStatus(ids, 'Enabled')
        .then(() => {
          dispatch({ type: ENABLED_MULTIPLE, ids });
          dispatch(loadPhones()).then(resolve);
        })
        .catch((err) => {
          dispatch({ type: ENABLE_MULTIPLE_FAILED, ids, error: err });
          reject(err);
          return;
        });
    });
  };
};

export const DISABLING_MULTIPLE = 'PHONE_CONTROL/DISABLING_MULTIPLE';
export const DISABLED_MULTIPLE = 'PHONE_CONTROL/DISABLED_MULTIPLE';
export const DISABLE_MULTIPLE_FAILED = 'PHONE_CONTROL/DISABLE_MULTIPLE_FAILED';
export const disableMultiple = (ids) => {
  return (dispatch) => {
    dispatch({ type: DISABLING_MULTIPLE, ids });

    return new Promise((resolve, reject) => {
      resources.station
        .putMultipleStatus(ids, 'Disabled')
        .then(() => {
          dispatch({ type: DISABLED_MULTIPLE, ids });
          dispatch(loadPhones()).then(resolve);
        })
        .catch((err) => {
          dispatch({ type: DISABLE_MULTIPLE_FAILED, ids, error: err });
          reject(err);
          return;
        });
    });
  };
};
